import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
  root: {
    width: 300,
    margin: 10,
  },
  media: {
    height: 140,
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 5,
  },
  contentRoot: {
    padding: 3,
    height: 20,
  },
  uploadTitle: {
    color: theme.palette.text.secondary,
  },
}));
